import {Register} from "./Register";
import {useHistory} from "react-router-dom";
import React from "react";

export function RegisterPage() {
    const history = useHistory();
    return <Register onShowLogin={() => history.push("/login")} />
}